// @ts-nocheck

import { CONFIG } from "~/config";

/* eslint-disable */
const LayerPano = function(id, opts) {
	this._opts = {
		pointsUrl: `${CONFIG.mapserver.url}/panorama_pt_hybrid-m/`,
		lineUrl: `${CONFIG.mapserver.url}/panorama_ln_hybrid-m/`,
		pointsZoom: 19,
		...opts,
	};
	this._event = null;
	this._imgsCache = {};
	this._imgsCacheZoom = -1;
	this._imgLoadTO = null;
	this._imgData = null;
	this._pending = 0;
	this._drawID = 0;
	this._filledTiles = false;
	this._emptyTileSize = -1;
	this._isLineActive = false;

	SMap.Layer.Canvas.call(this, id, SMap.LAYER_TILE);
}

LayerPano.prototype = Object.create(Object.assign({}, SMap.Layer.prototype, SMap.Layer.Canvas.prototype));

LayerPano.prototype.enable = function() {
	if (this._active) { return; }
	var node = this.getMap().getContainer();
	this._event = JAK.Events.addListener(node, "mousemove", this, "_mousemove");
	return SMap.Layer.Canvas.prototype.enable.call(this);
}

LayerPano.prototype.disable = function() {
	if (!this._active) { return; }
	this.getMap().getSignals().makeEvent("pano-unavailable", this);
	JAK.Events.removeListener(this._event);
	this._event = null;
	this._imgData = null;
	this._imgsCache = {};
	this._imgsCacheZoom = -1;
	this._drawID = 0;
	this._pending = 0;
	this._filledTiles = false;
	this._isLineActive = false;
	return SMap.Layer.Canvas.prototype.disable.call(this);
}

LayerPano.prototype.setLine = function(state) {
	const change = this._isLineActive != state;

	this._isLineActive = state;

	if (change) {
		this.redraw(true);
	}
};

LayerPano.prototype.getAvail = function() {
	var obj = {};

	if (this._filledTiles) {
		obj["pano-available"] = 1;
	}

	return obj;
};

LayerPano.prototype._mousemove = function(e) {
	var signals = this.getMap().getSignals();

	if (this._context) {
		var w = this._context.canvas.width;
		var h = this._context.canvas.height;
		var px = SMap.Pixel.fromEvent(e, this.getMap()).plus(new SMap.Pixel(w, h).scale(0.5));
		// pixel byl float -> je potreba to prevest na cele cislo
		var x = Math.floor(px.x);
		var y = Math.floor(px.y);
		// r, g, b, a
		var alpha = this._imgData ? this._imgData[(x * 4 + y * w * 4) + 3] : 0;
		var name = (alpha > 0 ? "available" : "unavailable");
		signals.makeEvent("pano-"+name, this);
	}
	else {
		signals.makeEvent("pano-unavailable", this);
	}
}

LayerPano.prototype.redraw = function(full) {
	SMap.Layer.Canvas.prototype.redraw.call(this, full);

	if (!this._active) { return; }

	this._drawID = Math.random();
	this._pending = 0;
	this._imgData = null;
	this._filledTiles = false;

	this.clear();

	var map = this.getMap();
	var zoom = map.getZoom();
	var half = map.getSize().clone().scale(0.5);
	var ts = SMap.Layer.Tile.DEFAULT_OPTIONS.tileSize;
	var half = map.getSize().clone().scale(0.5);
	var w = half.x;
	var h = half.y;

	if (zoom != this._imgsCacheZoom) {
		this._imgsCacheZoom = zoom;
		this._imgsCache = {};
	}

	const useLineUrl = zoom < this._opts.pointsZoom || this._isLineActive;
	const tileUrl = useLineUrl ? this._opts.lineUrl : this._opts.pointsUrl;

	for (var i=-w; i<w+ts; i+=ts) {
		for (var j=-h; j<h+ts; j+=ts) {
			var tile = new SMap.Pixel(i, j).toTile(map, ts);

			if (!tile) { continue; }

			var url = this._buildURL(tileUrl, tile);
			var tilePosition = tile.toPixel(map);

			this._drawTile(url, tilePosition.x + w, tilePosition.y + h, this._drawID);
		}
	}
}

/**
 * Vyrobí URL dlaždice
 * @param {SMap.Tile} tile instance Dlaždice
 * @returns {string} URL dlaždice
 */
LayerPano.prototype._buildURL = function(tileUrl, tile) {
	var url = tileUrl + this._buildQuery(tile);
	var mapServerNumber = 1 + ((tile.x + tile.y) & 3);

	url = url.replace(/#/, mapServerNumber);

	return ((url + (url.indexOf("?") == -1 ? "?" : "&")
			+ SMap.CONFIG.SDK.key + "=" + encodeURIComponent(SMap.getSDKHeaderValue()))
			+ (Loader.apiKey ? "&" + SMap.CONFIG.apiKeyParam + "=" + encodeURIComponent(Loader.apiKey) : ""));
}

LayerPano.prototype._buildQuery = function(tile) {
	var ppx = (tile.x << (28 - tile.zoom)).toString(16);
	var ppy = (tile.y << (28 - tile.zoom)).toString(16);

	var world = this._owner.getProjection().getWorldSize(tile.zoom);
	var count = world.x / tile.tileSize;
	return this.getMap().formatString(SMap.Layer.Tile.DEFAULT_OPTIONS.query, {ppx:ppx, ppy:ppy, x:tile.x.mod(count), y:tile.y});
}

LayerPano.prototype._drawTile = function(url, x, y, drawID) {
	if (!this._context) return;

	this._pending++;

	if (url in this._imgsCache) {
		this._context.drawImage(this._imgsCache[url], x, y);
		this._imageLoaded();
	}
	else {
		var img = new Image();
		img.onload = function() {
			if (!this._filledTiles) {
				var size = this._getImgBase64Size(img);

				if (size != this._emptyTileSize) {
					this._filledTiles = true;
				}
			}

			if (this._drawID == drawID) {
				this._imgsCache[url] = img;
				this._context.drawImage(img, x, y);
				this._imageLoaded();
			}
		}.bind(this);
		img.onerror = function(e) {
			//console.log(e);
			if (this._drawID == drawID) {
				this._imageLoaded();
			}
		}.bind(this);
		img.crossOrigin = CONFIG.mapserver.crossOrigin;
		img.src = url;
	}
};

LayerPano.prototype._imageLoaded = function() {
	this._pending--;

	if (!this._pending) {
		if (this._imgLoadTO) {
			clearTimeout(this._imgLoadTO);
			this._imgLoadTO = null;
		}

		this._imgLoadTO = setTimeout(function() {
			this._imgLoadTO = null;

			try {
				this._imgData = this._context.getImageData(0, 0, this._context.canvas.width, this._context.canvas.height).data;
			}
			catch (e) {
				//console.log(e);
			}

			this.getMap().getSignals().makeEvent("pano-availCheck", this);
		}.bind(this), 33);
	}
};

LayerPano.prototype._getImgBase64Size = function(img) {
	var newCanvas = document.createElement("canvas");
	newCanvas.width = SMap.Layer.Tile.DEFAULT_OPTIONS.tileSize;
	newCanvas.height = SMap.Layer.Tile.DEFAULT_OPTIONS.tileSize;

	if (this._emptyTileSize == -1) {
		this._emptyTileSize = newCanvas.toDataURL().length;
	}

	var size = this._emptyTileSize;

	try {
		var ctx = newCanvas.getContext("2d");
		ctx.drawImage(img, 0, 0);
		size = newCanvas.toDataURL().length;
	} catch (e) {
		/* eslint-disable no-console */
		console.log(e);
	}

	return size;
};

export default LayerPano;
